"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Error = function Error(_ref) {
  var message = _ref.message;
  var referenceCode = message.substring(message.indexOf("Ref:"), message.lastIndexOf("]"));
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: "exclamation-circle",
    iconSize: 100,
    iconColor: "#bdbdbd"
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "textSecondary",
    variant: "h6",
    gutterBottom: true
  }, "Something went wrong"), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    component: "div"
  }, referenceCode ? "An error occurred (".concat(referenceCode, "). ") : "An unknown error occurred. ", "Please try again later.")));
};

Error.defaultProps = {
  message: ""
};
Error.propTypes = {
  message: _propTypes["default"].string
};
var _default = Error;
exports["default"] = _default;